import Store from "../Store";

const ChallengesStore = new Store("challenges");

export { ChallengesStore };
